import { motion } from 'framer-motion';
import { FaLinkedin, FaGithub, FaArrowUp } from 'react-icons/fa';
import { FaXTwitter } from 'react-icons/fa6';
import { PORTFOLIO_DATA } from '../../data/constants.js';
import { socialIconHover, buttonHoverGlow } from '../../utils/animationVariants.js';

const Footer = () => {
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };

    const socialLinks = [
      {
        name: "LinkedIn",
        url: PORTFOLIO_DATA.social.linkedin,
        icon: FaLinkedin,
        color: "hover:text-blue-600",
      },
      {
        name: "GitHub",
        url: PORTFOLIO_DATA.social.github,
        icon: FaGithub,
        color: "hover:text-gray-100",
      },
      {
        name: "X/Twitter",
        url: PORTFOLIO_DATA.social.twitter,
        icon: FaXTwitter,
        color: "hover:text-blue-400",
      },
    ];

    return (
        <footer className="bg-gray-900 text-white mt-auto">
            <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-12">
                <div className="flex flex-col items-center justify-center space-y-6 sm:space-y-8">
                    {/* Social Links */}
                    <div className="flex space-x-6 sm:space-x-8">
                        {socialLinks.map((social) => {
                            const IconComponent = social.icon;
                            return (
                                <motion.a
                                    key={social.name}
                                    href={social.url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    whileHover={socialIconHover}
                                    whileTap={{ scale: 0.9 }}
                                    className={`text-gray-400 transition-colors duration-300 ${social.color}`}
                                    aria-label={`Visit ${social.name} profile`}
                                >
                                    <IconComponent className="h-6 w-6 sm:h-7 sm:w-7" />
                                </motion.a>
                            );
                        })}
                    </div>

                    {/* Copyright */}
                    <div className="text-center">
                        <p className="text-gray-400 text-sm sm:text-base">
                            © {new Date().getFullYear()} {PORTFOLIO_DATA.personal.name}. All rights reserved.
                        </p>
                        <p className="text-gray-500 text-xs sm:text-sm mt-2">
                            Built with React, Tailwind CSS, and Framer Motion
                        </p>
                    </div>

                    {/* Back to Top Button - Fixed position on mobile, absolute on larger screens */}
                    <div className="relative w-full flex justify-center">
                        <motion.button
                            onClick={scrollToTop}
                            whileHover={buttonHoverGlow}
                            whileTap={{ scale: 0.9 }}
                            className="bg-blue-600 hover:bg-blue-700 text-white p-3 sm:p-4 rounded-full shadow-lg transition-colors duration-300 sm:static fixed bottom-6 right-6 z-30 touch-manipulation"
                            aria-label="Back to top"
                        >
                            <FaArrowUp className="h-4 w-4 sm:h-5 sm:w-5" />
                        </motion.button>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;